var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOwnercomponent = function SvgOwnercomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6c1.875 0 3.429-1.336 3.429-3 0-1.64-1.554-3-3.429-3-1.902 0-3.429 1.36-3.429 3 0 1.664 1.527 3 3.429 3Zm2.384.75h-.455c-.59.258-1.233.375-1.929.375s-1.366-.117-1.955-.375h-.456C1.607 6.75 0 8.18 0 9.914v.961C0 11.508.563 12 1.286 12h9.428c.697 0 1.286-.492 1.286-1.125v-.96C12 8.18 10.366 6.75 8.384 6.75Z",
    fill: "current"
  })));
};
export default SvgOwnercomponent;